import { createAsyncThunk } from "@reduxjs/toolkit";
import axiosInstance from "../../../service/axiosInstance";

export const fetchSummerPodcasts = createAsyncThunk(
  "summerPodcasts/fetch",
  async (_, { rejectWithValue }) => {
    try {
      const response = await axiosInstance.get("summer-podcasts/");
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message);
    }
  }
);
